<template>

    <form ref="avaliacaoquestao-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="disciplinaId">Disciplina</label>
                <select v-select="{ dataitem: 'AuxDisciplina', default: 'Selecione' }" v-model="model.disciplinaId" class="form-control" name="disciplinaId" required></select>
            </div>
            <div class="form-group col-md-12">
                <label for="numeroQuestoes">Número de Questões</label>
                <input type="number" class="form-control" name="numeroQuestoes" placeholder="Número de Questões" v-model="model.numeroQuestoes" required />
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "avaliacaoquestao-form-create",
        props: { avaliacaoId: Number },
        mixins: [base],
        data: () => ({

            model: {},

            form: "avaliacaoquestao-form-create",

            resources: {
                create: 'avaliacaoquestao',
            },

        }),

        methods: {

            executeCreate: function (model) {

                model.avaliacaoId = this.avaliacaoId;

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

